import { useFormikContext } from 'formik';
import get from 'lodash/get';
import React from 'react';

import { DefaultItemProps, Select } from '@candu-ai/analytics/ui';
import { DefinitionDatePicker } from 'dashboard/pages/Segment/components/DefinitionFormFields/DefinitionDatePicker';
import { SelectInputWrapper } from 'dashboard/pages/Segment/components/DefinitionFormFields/DefinitionFormComponents';
import { limitedTimeContentOptions } from 'dashboard/pages/Segment/components/constants';
import { DefinitionFormikValues } from 'dashboard/pages/Segment/components/types';

export interface LimitedTimeContentRuleProps {
  base: string;
  readOnly?: boolean;
}

export const LimitedTimeContentRule = ({ base, readOnly }: LimitedTimeContentRuleProps) => {
  const { values, setFieldValue } = useFormikContext<DefinitionFormikValues>();

  const operationTypePath = `${base}.LimitedTimeContent.operation.type`;
  const operandDatePath = `${base}.LimitedTimeContent.operation.operand`;

  const value = get(values, operationTypePath);

  return (
    <>
      <Select<DefaultItemProps, DefinitionFormikValues>
        name={operationTypePath}
        readOnly={readOnly}
        options={limitedTimeContentOptions}
        placeholder="Choose operator"
        InputWrapper={SelectInputWrapper}
        data-cy="segment-definition-selector"
        values={values}
        setFieldValue={setFieldValue}
        validateOnSelectWithErrors
      />
      {value && value !== '' && <DefinitionDatePicker name={operandDatePath} readOnly={readOnly} />}
    </>
  );
};
